// extracted by mini-css-extract-plugin
module.exports = {"apptDetailsDatetime":"appt-details-datetime__8c5hv","apptDetailsHelperText":"appt-details-helper-text__JT-oN"};